import React, { useState, useEffect } from 'react';
import {connect} from 'react-redux';
import styles from './ProductSpecificationBtnViewStyle.scss'
import withRipple from 'jd-library/withRipple';
import InfoTag from '../../../info-tag/InfoTag';
import ProgressSvgComponent from '../../../progressSvgComponent/ProgressSvgComponent';

function ProductSpecificationBtnView(props) {
    const {
        savedPuvSpecAttributes,
        productSpecificationFormElement,
        savedCustomSpecAttributes,
        toggleSlider,
        session,
        showSellOnline,
        contentWeightUnitSaved,
        productOrService,
        editablePuvSpecAttributes
    } = props;

    const mandatoryNode = showSellOnline || productOrService == 'service' ? 's_mandatory' : 's_re_mandatory';
    const mandatoryFields = editablePuvSpecAttributes.filter(cur => cur[mandatoryNode] == '1');
    const isMandatoryFieldEmpty = mandatoryFields?.length ? !ifValuesPresent(mandatoryFields,[]): undefined;
    console.log(isMandatoryFieldEmpty);
    const AddSpecification = withRipple((props) => (
        <div
            className={`${styles["section-container"]} ${styles[!session.isReadOnly ? 'specification-background' : '']} ${styles["action-btn"]} ${props.rippleClass}`} {...props.rippleHandler}
            onClick={() => session.isReadOnly ? null : toggleSlider()}>
            <div className={styles["head-text"]}>
                <span>Add Specifications</span>
                {(props[showSellOnline || productOrService == 'service'  ? 's_mandatoryPresent': 're_mandatoryPresent'] || (props.hasCompliance && showSellOnline) && productOrService == 'product') || ((props.installationFlag || props.showInstall) && showSellOnline && !props.installData[0].values.length && !props.installData[1].values.length) ?
                    !props.isAuditor && !props.session?.viaOmni ? 
                <InfoTag info={'Please Enter Mandatory Fields'} tagIconClass={'icon-alert_outline'} /> : null
                :null}
                {!session.isReadOnly && <i className={"icon-Next"}></i>}
            </div>
            {!props.session?.viaOmni && !props.isTemplateProduct && !props.isAuditor && ((showSellOnline && !props[showSellOnline || productOrService == 'service' ? 's_mandatoryPresent': 're_mandatoryPresent']) || !showSellOnline)?
            <ProgressSvgComponent
                text={'Help Your Customers Find What They Want by Uploading More Specifications'}
                styleParent={styles['marginT12']}
            />
            : null}
            {props.renderRipple()}
        </div>
    ))
    return (
        ((ifValuesPresent(savedPuvSpecAttributes, savedCustomSpecAttributes, props.installData, contentWeightUnitSaved) || props?.isEnrichSpec) ?
            <RenderSpecificationView
                toggleSlider={toggleSlider}
                savedPuvSpecAttributes={savedPuvSpecAttributes}
                savedCustomSpecAttributes={savedCustomSpecAttributes}
                isReadOnly={session.isReadOnly}
                installData={props.installData}
                contentWeightUnitSaved={contentWeightUnitSaved}
                isTemplateProduct={props.isTemplateProduct}
                isAuditor={props.isAuditor}
                session={session}
                infoTag={((props[showSellOnline || productOrService == 'service'  ? 's_mandatoryPresent': 're_mandatoryPresent'] || (props.hasCompliance && showSellOnline) && productOrService == 'product') || ((props.installationFlag || props.showInstall) && showSellOnline && !props.installData[0].values.length && !props.installData[1].values.length)) && isMandatoryFieldEmpty ?
                    !props.isAuditor && !props.session?.viaOmni? 
                <InfoTag info={'Please Enter Mandatory Fields'} tagIconClass={'icon-alert_outline'} /> : null
                :null
                }
            />
        :
            <AddSpecification {...props} />
    ));
}

function ifValuesPresent(savedPuvSpecAttributes, savedCustomSpecAttributes, installData, contentWeightUnitSaved){
    const isSpecificationValuePresent = savedPuvSpecAttributes.some ( i => {
        if(['brand','manufacturer','manufactured_details','importer','importers_detail','price','country_of_origin','packaging_width','packaging_height','packaging_length','packaging_weight','expiry_date'].includes(i.s_nm.toLowerCase())){
            return false;
        }
        const type = i.s_type.toLowerCase();
        switch(type){
            case "textbox":
            case "textarea":
            case "textboxautosuggest":
                if(i.s_subType && i.userInput.textboxValue && i.userInput.value){
                    return true;
                }

                if(i.userInput.value){
                    return true;
                }
            case "rangebox":
                if(i.userInput.value && Array.isArray(i.userInput.value) && i.userInput.value.length){
                    return true;
                }
            case "dropdown":
            case "dropdownautosuggest":
                if(i.userInput.textboxValue || i.userInput.value){
                    return true;
                }
            case "checkbox":
            case "checboxautosuggest":
                if(i.userInput.value && Array.isArray(i.userInput.value) && i.userInput.value.some(k => k.checked)){
                    return true;
                }
            default:
                return false;
        }
    })

    const isCustomAttributePresent = savedCustomSpecAttributes.some( i => !!i.key.value && !!i.value.value);

    const iscontentWeightUnitSavedPresent = contentWeightUnitSaved && contentWeightUnitSaved.contentPerPiece && contentWeightUnitSaved.contentPerPiece.value.length && contentWeightUnitSaved.unitPerPiece && contentWeightUnitSaved.unitPerPiece.value.length;

    return isSpecificationValuePresent || isCustomAttributePresent || installData && installData.some(e => e.values.length) || iscontentWeightUnitSavedPresent;
}

function generateViewableData(data){
    return data.reduce((acc, item) => {
        const value = [];
        if(!['brand','manufacturer','manufactured_details','importer','importers_detail','country_of_origin','price','packaging_width','packaging_height','packaging_length','packaging_weight','expiry_date'].includes(item.s_nm.toLowerCase())){
            if(item.userInput.value && ["checkbox", "checkboxautosuggest"].includes(item.s_type.toLowerCase())){
                const obj = {
                    label: item.s_dnm,
                    value: Array.isArray(item.userInput.value) ? item.userInput.value.reduce((val, o ) => {
                        if(o.checked && !o.label.toLowerCase().includes('other')){
                            val.push(o.label);
                        }
                        return val;
                    },value).join(", ") : item.userInput.value
                }
                if(!!item.userInput.textboxValue){
                    obj.value += `, ${item.userInput.textboxValue}`;
                }
                acc.push(obj);
            }
            if(["dropdown", "rangebox", 'textbox', "textarea", "textboxautosuggest","fixed","dropdownautosuggest"].includes(item.s_type.toLowerCase())){
                if(item.userInput.value){
                    value.push(item.userInput.value);
                    if(item.userInput.textboxValue  && item.s_subType != 'UnitboxWithFixedbox' && !(item.s_subType == 'UnitboxWithDropdown' && item.s_unit_pos==1)){
                        value.push(item.userInput.textboxValue); 
                    } 
                    acc.push({
                        label: item.s_dnm,
                        value: value.join(" - "),
                        unit: item.s_unit?.length ? item.s_unit[0] : (item?.sunit ? item.sunit : ''),
                        subType: item.s_subType,
                        unit_pos: item.s_unit_pos
                    });
                } else if(item.s_type == 'Fixed'){
                    acc.push({
                        label: item.s_dnm,
                        value: item.s_type_options[0],
                        unit: item.s_unit_pos == "0" && item.s_unit?.length ? item.s_unit[0] : '',
                        subType: item.s_subType
                    })
                }
            }
            if(item.s_type.toLowerCase() == 'date') {
                if(item.userInput.value) {
                    acc.push({
                        label: item.s_dnm,
                        value: item.userInput.value.toString(),
                    })
                }
            }
        }
        return acc;
    }, [])
}

function generateCustomAttrViewableData(data){
    return data.reduce((acc, item) => {
        if(!!item.key.value && !!item.value.value && !['manufacturer', 'manufactured_details','ins_days','ins_amount','ins_cover','ins_not_cover','expiry_date'].includes(item.key.value.toLowerCase())){
            acc.push({
                label: item.key.value,
                value: item.value.value
            });
        }
        return acc;
    }, []);
}

function RenderSpecificationView(props){

    const [toggleShowMore, setToggleShowMore] = useState(false);
    const [savedSpecificationData, setSavedSpecificationData] = useState([]);
    const maxProps = 5;
    const { savedPuvSpecAttributes, toggleSlider, savedCustomSpecAttributes, contentWeightUnitSaved } = props;


    useEffect(() => {
        if(ifValuesPresent(savedPuvSpecAttributes, savedCustomSpecAttributes)){
            const convertedSpecificationData = generateViewableData(savedPuvSpecAttributes);
            const convertedCustomAttributeData = generateCustomAttrViewableData(savedCustomSpecAttributes);
            const combinedData = [...convertedSpecificationData,...convertedCustomAttributeData];
            setSavedSpecificationData(combinedData);
            setToggleShowMore(combinedData.length > maxProps ? true : false);
        }else{
            setSavedSpecificationData([])
            setToggleShowMore(false);
        }
    }, [savedPuvSpecAttributes, savedCustomSpecAttributes])

    function showMoreHandle() {
        const container = document.querySelector(".add-edit-container")
        if(container){
            const wrapper = container.querySelector(".collapsible-div .wrapped-component");
            if(!!wrapper){
                toggleShowMore ? wrapper.classList.add("increase-height") : wrapper.classList.remove("increase-height");
            }
        }
        setToggleShowMore(!toggleShowMore);
    }

    const dataToRender = toggleShowMore ? savedSpecificationData.slice(0, maxProps) : savedSpecificationData;

    return (
        <div
            className={`${styles["section-container"]} ${styles['edit-mode']}`}
            style={{ paddingTop: '15px' }}
        >
            <div className={`${styles["head-text"]} ${styles['spec-view']}`}>
                <span>{!dataToRender.length && !props?.isEnrichSpec ? "Add" : ""} Specifications</span>
                {!props.session.isReadOnly ? <span className={styles["edit-btn"]} onClick={() => toggleSlider()}>
                    <i className="icon-editItem"></i>
                    <span className={styles["specification-edit"]}> Edit</span>
                </span> : null}
            </div>
            {props.infoTag ? props.infoTag : null}
            <ul className={styles["specification-list"]}>
                { props.installationFlag ?
                    props.installData.map((cur,index) => {
                            return cur.values && cur.values.length && (
                                <li key={`${cur.name}-${index}`}>
                                <span className={styles["specification-item-key"]}>{cur.s_nm}</span>
                                <span className={styles["specification-item-value"]}>
                                    {cur.values.toString()}
                                </span>
                            </li>
                            ) || null;
                    })
                    : null
                }
                {dataToRender.map((item, index) => {
                    if(item.value){
                        return (
                            <li key={`${item.label}-${item.index}`}>
                                <span className={styles["specification-item-key"]}>{item.label}</span>
                                <span className={styles["specification-item-value"]}>
                                    {item.unit_pos && item.unit_pos == 1 ? item.unit: typeof item.value == "string" ? item.value.replace("Others - ",'').replace(/-/g, " ") : item.value("-",' ').replace(/-/g, " ")}
                                    {item.unit && !(item.subType =='UnitboxWithDropdown' && item.unit_pos==0) ?<div className={styles['specification-item-unit']}>{item.unit_pos == 1 ? item.value : item.unit}</div>:null}    
                                </span>
                            </li>
                        )
                    }else{
                        return null;
                    }
                })}
                {
                    contentWeightUnitSaved.contentPerPiece && contentWeightUnitSaved.unitPerPiece && contentWeightUnitSaved.contentPerPiece.value.length && contentWeightUnitSaved.unitPerPiece.value.length &&
                    (
                        <li key={`contentperpiece-unitperpiece`}>
                            <span className={styles["specification-item-key"]}>Net Weight/Content</span>
                            <span className={styles["specification-item-value"]}>
                                {`${contentWeightUnitSaved.contentPerPiece.value.toString()} ${contentWeightUnitSaved.unitPerPiece.value.toString()}`}
                            </span>
                        </li>
                    ) || null
                }
            </ul>
            {
                savedSpecificationData.length > maxProps && (
                    <div className={styles['show-more-btn-wrapper']}>
                        <div className={styles['show-more-btn']} onClick={showMoreHandle}>
                            <span className={`${styles['toggleicon']}`}>{toggleShowMore ? "+": "-"}</span>
                            <span className={styles["toggle-btn-text"]}>
                                View { toggleShowMore ? "More" : "Less" }
                            </span>
                        </div>
                    </div>
                )
            }
            {!props.session?.viaOmni && !props.isAuditor && savedSpecificationData.length < maxProps && !props.isTemplateProduct ? (
                    <ProgressSvgComponent
                        text={'Help Your Customers Find What They Want by Uploading More Specifications'}
                    />
            ): null}
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        savedPuvSpecAttributes: state.productSpecification.savedPuvSpecAttributes,
        editablePuvSpecAttributes: state.productSpecification.editablePuvSpecAttributes,
        savedCustomSpecAttributes: state.productSpecification.savedCustomSpecAttributes ? state.productSpecification.savedCustomSpecAttributes: [],
        s_mandatoryPresent: state.productSpecification.s_mandatoryPresent,
        re_mandatoryPresent: state.productSpecification.re_mandatoryPresent,
        installationFlag: state.productSpecification.installationFlag,
        isEnrichSpec: state.productSpecification?.isEnrichSpec,
        installData: state.brandManufacturer.installData,
        contentWeightUnitSaved: state.brandManufacturer.contentWeightUnitSaved,
        session: state.session,
        showInstall: state.products.editProduct?.showInstall,
        hasCompliance: state.products.editProduct?.hasCompliance,
        isTemplateProduct: state.products.editProduct?.isTemplate || state.products.editProduct?.isTempProd,
        isAuditor: state.session?.user?.loggedUser?.userType=='AUDITOR'
    }
}

export default connect(mapStateToProps, null)(ProductSpecificationBtnView);